// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7fe4367c","455":"9da53a6e","977":"c7682801"}[chunkId] + ".chunk.js";
};